import ClearIcon from '@mui/icons-material/Clear';
import { useMemo } from 'react';
import { TableActionType, useTableContext, useTableDispatch } from './State';

interface IMassActionsProps {
  onRenderActions?: (selectedItems: any[]) => React.ReactNode;
}

const MassActions: React.FC<IMassActionsProps> = ({ onRenderActions }) => {
  const { selectedItems } = useTableContext();
  const { dispatch } = useTableDispatch();

  const isVisible = useMemo(() => selectedItems?.length > 0, [selectedItems]);

  const handleClearSelection = () => {
    dispatch({ type: TableActionType.CLEAR_SELECTED_ITEMS });
  };

  // Don't render if no items selected
  if (!isVisible) return null;

  return (
    <div className='fixed z-[9999] bottom-20 left-[50%] -translate-x-[50%] flex items-center justify-center transition-all duration-300'>
      <div className='flex items-center bg-neutral-80 text-white rounded-8 pl-24 pr-12 py-12'>
        <div className='text-14'>{selectedItems?.length} items selected</div>
        <button aria-label='Clear' type='button' className='ml-8 flex items-center justify-center' onClick={handleClearSelection}>
          <ClearIcon style={{ color: '#ffffff', fontSize: 20 }} />
        </button>
        {onRenderActions && <div className='ml-[160px] flex items-center'>{onRenderActions(selectedItems)}</div>}
      </div>
    </div>
  );
};

export default MassActions;
